/***
 * 这个文件定义前端常量
 */

// 通过 value 获取 key
const getKeyByValue = (object, value) => {
    return Object.keys(object).find((key) => object[key] === value);
};

// 性别
const SEX = {
    0: "女",
    1: "男",
};

// 岗位层级
const STATION_LEVEL = {
    1: "基层员工",
    2: "基层主管",
    3: "项目团队",
    4: "中层",
    5: "高层",
};

// 人员状态
const PERSON_STATES = {
    0: "在职",
    1: "离职",
};

// 系列状态
const SERIES_STATES = {
    0: "已下架",
    1: "已上架",
};

//课程状态
const CLASS_STATES = {
    0: "待提交",
    1: "待审核",
    2: "已通过",
    3: "未通过",
};

// 审批状态
const APPROVAL_STATES = {
    1: "待审核",
    2: "已通过",
    3: "未通过",
};

// 大纲课程形式
const MODULE_TYPE = {
    audioText: "文字转音频",
    video: "视频",
    image: "图片",
    dialogSelect: "聊天框选择",
    text: "问答题",
    select: "单选题",
    multipleSelect: "多选题",
    judge: "判断题",
    sort: "排序题",
    imageSelect: "图片选择",
    richText: "富文本",
    audio: "音频",
};

const CONTENT_TYPE = {
    content: "课程正文",
    subject: "练习题",
};

const CONTENT_PATTERN = {
    audioText: "文字转音频",
    image: "图片",
    audio: "音频",
    video: "视频",
};

const SUBJECT_TYPE = {
    select: "单选题",
    judge: "判断题",
    multipleSelect: "多选题",
    sort: "排序题",
    text: "问答题",
};

const QUESTION_TYPE = {
    select: "单选题",
    judge: "判断题",
    multipleSelect: "多选题"
};

// 回答状态
const ANSWER_STATES = {
    0: "待回答",
    1: "已回答",
};

// 订单状态
const ORDER_STATES = {
    1: "已完成",
    0: "待支付",
    2: "已关闭",
};

// 打卡类别
const CLOCK_TYPE = {
    0: "打卡知识点",
    1: "课程知识点",
};

// 课包状态
const PRODUCTION_STATES = {
    0: "下架",
    1: "上架",
};
// 付费方式
const PAY_TYPE = {
    0: "免费",
    1: "付费",
};

// 课程类型
const COURSE_TYPE = {
    0: "互动",
    1: "特色",
};

// 学历等级
const EDUCATION_LEVEL = {
    20: "硕士及以上",
    3: "本科",
    2: "大专",
    "-10": "高中",
    "-15": "初中",
    "-30": "初中以下",
    null: "-",
};

const WORK_ORDER_HANDLED = {
    null: "全部",
    true: "已处理",
    false: "未处理",
};

const LEARNING_STEP = {
    0: "内容学习",
    1: "随堂测试",
    2: "测试完成",
};

const LEARNING_STATES = {
    0: "未解锁",
    1: "学习中",
    2: "已学完",
};

const PACKAGE_TYPE = {
    0: "免费版",
    1: "标准版A",
    2: "标准版B",
    3: "旗舰版",
    4: "尊享版",
};
export {
    getKeyByValue,
    SEX,
    STATION_LEVEL,
    PERSON_STATES,
    SERIES_STATES,
    CLASS_STATES,
    MODULE_TYPE,
    CONTENT_TYPE,
    CONTENT_PATTERN,
    SUBJECT_TYPE,
    QUESTION_TYPE,
    APPROVAL_STATES,
    ANSWER_STATES,
    ORDER_STATES,
    CLOCK_TYPE,
    PRODUCTION_STATES,
    PAY_TYPE,
    EDUCATION_LEVEL,
    COURSE_TYPE,
    WORK_ORDER_HANDLED,
    LEARNING_STEP,
    LEARNING_STATES,
    PACKAGE_TYPE,
};
